"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscriptions = void 0;
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
function status(subscription) {
    if (!subscription.ends_at) {
        return 'opzeggen';
    }
    return subscription.ended ? 'beëndigd' : "eindigt op " + subscription.ends_at;
}
var Subscriptions = function (_a) {
    var user = _a.user, channel = _a.channel;
    var _b = ra_fetch_1.useApi('ecommerce').index('subscriptions', {
        user_id: user.id,
        channel_id: channel.id,
        sort: 'id desc',
    }), subscriptions_user = _b[0], setSubscriptions = _b[1];
    var _c = ra_fetch_1.useApi('ecommerce')
        .records(setSubscriptions, subscriptions_user.data)
        .update('subscriptions.cancel'), update = _c[0], setUpdate = _c[1], submitUpdate = _c[2];
    if (subscriptions_user.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    return react_1.default.createElement(storybook_1.Layouts.Container, { type: 'sm', className: 'storybook-layouts-space' },
        react_1.default.createElement(storybook_1.Texts.Heading, { appendClassname: 'text-center mb-4' }, "Mijn abonnementen"),
        react_1.default.createElement("div", { className: 'space-y-4' },
            !subscriptions_user.data.length &&
                react_1.default.createElement(storybook_1.Forms.New, { to: process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/subscriptions", description: 'Je hebt nog geen abonnementen.', label: 'Aanbod bekijken' }),
            subscriptions_user.data.map(function (subscription, index) { return react_1.default.createElement(storybook_1.Cards.Card, { key: index },
                react_1.default.createElement(storybook_1.Cards.Content, { className: 'flex justify-between items-center' },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(storybook_1.Texts.Primary, null, subscription.plan.label),
                        subscription.cycle_ends_at && react_1.default.createElement(storybook_1.Texts.Secondary, null,
                            "wordt verlengd op ",
                            subscription.expires_at)),
                    react_1.default.createElement(storybook_1.Buttons.Button, { disabled: subscription.ends_at, type: 'light', icon: 'ban', outline: true, onClick: function () { return submitUpdate({ id: subscription.id }); } }, status(subscription)))); })));
};
exports.Subscriptions = Subscriptions;
exports.Subscriptions.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
};
